import { kbbTheme } from '@argo/themes';
export default kbbTheme.typography;
//# sourceMappingURL=index.js.map